import SettingMenu from './SettingMenu';
import  './settingMenu.scss';

export default SettingMenu;